<div class="importer-page">
  <div class="importer-header">
    <div class="backButton" (click)="cancel.emit()">
      <img src="/assets/icons/arrow-left.svg" alt="Go back" />
    </div>
    <p class="page-title">{{ 'Import Data' | translate }}</p>
    <p class="page-subtitle">{{ 'Choose the type of data you want to import. You can import from CSV files or connect direct integrations.' | translate }}</p>
  </div>

  <div class="type-grid">
    <div class="type-card" *ngFor="let type of importTypes">
      <div class="type-icon">
        <img [src]="type.icon" [alt]="type.title" />
      </div>
      <h3 class="type-title">{{ type.title | translate }}</h3>
      <p class="type-desc">{{ type.desc | translate }}</p>
      <button class="import-btn" (click)="typeSelected.emit(type.id)">
        {{ type.buttonLabel | translate }}
      </button>
    </div>
  </div>

  <div class="filter-section">
    <label class="filter-btn" for="filterMissingInput">
      <img src="assets/icons/cart_gray.svg" alt="filter" />
      {{ 'Filter Out Existing Products' | translate }}
      <input type="file" id="filterMissingInput" accept=".csv" (change)="filterFileSelected.emit($event)" hidden />
    </label>
  </div>
</div>
